import React from "react";
import { Box, Typography } from "@material-ui/core";

const SalesPerPoundOfStaffCostTitle = () => {
    const label = "Sales per pound of staff cost";

    return (
        <Box display="flex" data-cy="sales-per-pound-of-staff-cost-title" pb={1}>
            <Typography variant="h6">{label}</Typography>
        </Box>

    );
};

export default SalesPerPoundOfStaffCostTitle; 
